import handleResponse from '../services/api'
import {put, call, fork, take, cancel} from 'redux-saga/effects'
import { generalError } from '../actions'

export function * apiWorker(apiFunction, successAction, failureAction, params = {}, fields = { default: true }, successDataFunction = d => d.result) {
  try {
    const response = yield call(apiFunction, params, fields)
    yield handleResponse(
      response,
      function * onOk (key, data) {
        yield put(successAction(successDataFunction(data)))
      },
      function * onFail (key, message, code) {
        yield put(failureAction(message, code))
      }
    )
  } catch (e) {
    yield put(failureAction(e.message, 0))
  }
}

export const apiFunction = (api, apiCall, successFtn, failureFtn, params = [], fields = { default: true }, preCallFtn = () => ({ }), exceptionFtn = null) => {
  return function * (action) {
    try {
      const precallParams = yield preCallFtn(action)
      const callParams = {
        ...precallParams,
        ...params.reduce((acc, param) => {
          acc[param] = action[param]
          return acc
        }, {}),
      }
      const response = yield call(apiCall, callParams, fields)
      yield api.handleResponse(
        response,
        successFtn,
        failureFtn
      )
    } catch (e) {
      if (exceptionFtn !== null) {
        yield exceptionFtn(e)
      } else {
        console.error(e)
        yield put(generalError())
      }
    }
  }
}

export const simpleApiFunction = (api, apiCall, successAction, failureAction, params = [], fields = { default: true }, exceptionFtn = null) => apiFunction(api,
  apiCall,
  function * (key, data) {
    yield put(successAction(data.result))
  },
  function * (key, message, code) {
    yield put(failureAction(message, code))
  },
  params,
  fields,
  () => ({ }),
  exceptionFtn)


export const takeLatestWithKey = (patternOrChannel, saga, keyField) => fork(function*() {
  const lastTasks = []
  while (true) {
    const action = yield take(patternOrChannel)
    const key = action[keyField] || 0
    const lastTask = lastTasks[key]
    if (lastTask) yield cancel(lastTask)
    lastTasks[key] = yield fork(saga, action)
  }
})